/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminProductListAnalyticsListing
 */
export interface AdminProductListAnalyticsListing {
    /**
     * 
     * @type {number}
     * @memberof AdminProductListAnalyticsListing
     */
    gapRatio?: number;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminProductListAnalyticsListing
     */
    marketplace: AdminMarketplaceType;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductListAnalyticsListing
     */
    reasons: Array<string>;
    /**
     * Severity and Reasons take AdminListingSeverity and AdminListingReason values.
     * @type {string}
     * @memberof AdminProductListAnalyticsListing
     */
    severity: string;
}



export function AdminProductListAnalyticsListingFromJSON(json: any): AdminProductListAnalyticsListing {
    return AdminProductListAnalyticsListingFromJSONTyped(json, false);
}

export function AdminProductListAnalyticsListingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListAnalyticsListing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gapRatio': !exists(json, 'gapRatio') ? undefined : json['gapRatio'],
        'marketplace': AdminMarketplaceTypeFromJSON(json['marketplace']),
        'reasons': json['reasons'],
        'severity': json['severity'],
    };
}

export function AdminProductListAnalyticsListingToJSON(value?: AdminProductListAnalyticsListing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gapRatio': value.gapRatio,
        'marketplace': AdminMarketplaceTypeToJSON(value.marketplace),
        'reasons': value.reasons,
        'severity': value.severity,
    };
}

